import { combineReducers } from 'redux';

import CaseTypes from './case.types';
import AnyAction from 'store/anyActions';
import {
    CaseSearchState,
    ContactState,
    CurrentCaseState,
    FasciasState,
    NewCaseState,
    UploadAttachmentsState
} from './case.state';

const defaultState: CurrentCaseState = {};

const currentCaseReducer = function (state: CurrentCaseState = defaultState, action: AnyAction): CurrentCaseState {
    switch (action.type) {
        case CaseTypes.GET_CASE_SUCCESS:
            return {
                ...action.payload,
            };
        case CaseTypes.UPDATE_CASE_SUCCESS:
            return {
                ...state,
                ...action.payload,
            };
        case CaseTypes.CREATE_MESSAGE_SUCCESS:
            return {
                ...state,
                messages: [action.payload, ...(state.messages || [])],
            };
        case CaseTypes.GET_CASE:
            if (action.payload === state.ID) {
                return state;
            }
            //Clear state if getting a different case
            return {};
        case CaseTypes.EXIT_CASE:
            return {};
        default:
            return state;
    }
}

const caseSearchReducer = function (state: CaseSearchState = null, action: AnyAction): CaseSearchState {
    switch (action.type) {
        case CaseTypes.SEARCH_CASES_SUCCESS:
            return [...action.payload];
        case CaseTypes.SEARCH_CASES:
        case CaseTypes.SEARCH_CASES_RESET:
        case CaseTypes.CLEAR:
            return null;
            default:
                return state;
            }
        }

const isSearchLoadingReducer = function (state: boolean = false, action: AnyAction): boolean {
    switch (action.type) {
        case CaseTypes.SEARCH_CASES:
            return true;
        case CaseTypes.SEARCH_CASES_SUCCESS:
        case CaseTypes.SEARCH_CASES_FAILURE:
        case CaseTypes.SEARCH_CASES_RESET:
            return false;
        default:
            return state;
        }
}

const getContactByCaseIDReducer = function (state: CaseSearchState = null, action: AnyAction): ContactState {
    switch (action.type) {
        case CaseTypes.GET_CONTACT_BY_CASE_ID_SUCCESS:
            return action.payload;
        case CaseTypes.GET_CONTACT_BY_CASE_ID_FAILURE:
            return null;
        case CaseTypes.CLEAR:
            return null;
            default:
                return state;
            }
        }

const isContactLoadingReducer = function (state: boolean = false, action: AnyAction): boolean {
    switch (action.type) {
        case CaseTypes.GET_CONTACT_BY_CASE_ID:
            return true;
        case CaseTypes.GET_CONTACT_BY_CASE_ID_SUCCESS:
        case CaseTypes.GET_CONTACT_BY_CASE_ID_FAILURE:
            return false;
        default:
            return state;
        }
}

const uploadAttachmentsReducer = function (state: UploadAttachmentsState = [], action: AnyAction): UploadAttachmentsState {
switch (action.type) {
    case CaseTypes.UPLOAD_ATTACHMENT_ASK:
        return [...state, undefined];
        case CaseTypes.UPLOAD_ATTACHMENT_ADD: {
            // TODO: check if last item is undefined
            const attachments = state.slice(0, state.length - 1); // Remove undefind created by UPLOAD_ATTACHMENT_ASK
            return [...attachments, action.payload];
        }
        case CaseTypes.UPLOAD_ATTACHMENT_SUCCESS: {
            const attachments = [...state],
            attachmentIndex = attachments.findIndex(attachment => attachment?.filename === action.payload?.filename);
            if (attachmentIndex > -1) attachments[attachmentIndex] = action.payload
            return attachments;
        }
        case CaseTypes.UPLOAD_ATTACHMENT_REMOVE: {
            const attachments = [...state],
            attachmentIndex = attachments.findIndex(attachment => attachment?.filename === action.payload);

            attachments.splice(attachmentIndex, 1);
            return attachments;
        }
        case CaseTypes.GET_CASE:
        case CaseTypes.EXIT_CASE:
            case CaseTypes.EXIT_NEW_CASE:
            return [];
        default:
            return state;
    }
}

const newCaseReducer = function (state: NewCaseState = null, action: AnyAction) {
    switch (action.type) {
        case CaseTypes.START_NEW_CASE:
            if (action.payload) {
                return {
                    ...state,
                    fromName: action.payload.name,
                    fromAddress: action.payload.address,
                };
            } else {
                return {
                    title:'',
                }
            }
            case CaseTypes.CREATE_NEW_CASE_SUCCESS:
            case CaseTypes.UPDATE_NEW_CASE:
                return {
                    ...state,
                    ...action.payload
                };
            case CaseTypes.EXIT_NEW_CASE:
                return null;
        default:
            return state;
    }
}

const fasciasReducer = function (state: FasciasState = [], action: AnyAction) {

    switch (action.type) {
        case CaseTypes.GET_FASCIAS_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}

const caseReducer = combineReducers({
    currentCase: currentCaseReducer,
    searchResults: caseSearchReducer,
    isSearchLoading: isSearchLoadingReducer,
    contactResult: getContactByCaseIDReducer,
    isContactLoading: isContactLoadingReducer,
    newCase: newCaseReducer,
    fascias: fasciasReducer,
    uploadAttachments: uploadAttachmentsReducer
});

export default caseReducer;
